import {Component, OnInit} from '@angular/core';
import {Brand} from '../../../../brand/brand.model';
import {BrandService} from '../../../../brand/brand.service';
import {AgeMileageConfiguration} from '../../../../models/config/agemileageconfiguration.model';
import {HttpService} from '../../../../services/http.service';
import {AgeMileageMatrix} from '../../../../models/config/agemileagematrix.model';
import {SweetUtil} from '../../../commons/sweet/sweet-util-service';
import {AgeMileageFilter} from '../../../../models/config/agemileage-filter.model';

@Component({
  selector: 'app-age-mileage',
  templateUrl: './age-mileage.component.html',
  styleUrls: ['./age-mileage.component.scss']
})
export class AgeMileageComponent implements OnInit {
  selectedBrand: Brand = null;
  brands: Array<Brand> = [];
  ageMileageMatrix: AgeMileageMatrix;
  filter: AgeMileageFilter = new AgeMileageFilter();

  constructor(private http: HttpService, private brandService: BrandService, private sweetUtil: SweetUtil) { }

  ngOnInit(): void {
    this.brandService.all().subscribe((brands: Brand[]) => {
      this.brands = brands;
      this.selectedBrand = this.brands[0];
      this.filter.brand = this.selectedBrand.id;
      this.fetchConfiguration();
    });
  }

  fetchConfiguration() {
    this.http.fetchAgeMileageMatrix(this.filter).subscribe((res) => {
      this.ageMileageMatrix = res;
    });
  }

  getAgeInYears(age: number) {
    if (!age) {
      return 0;
    }
    return Math.round(age / 12);
  }

  getMileage(mileage: number) {
    if (!mileage) {
      return 0;
    }
    return mileage;
  }

  changePage(count: number) {
    this.filter.page += count;
    this.fetchConfiguration();
  }

  orderBy(field: string) {
    if (this.filter.orderBy === field) {
      if (this.filter.order === 'ASC') {
        this.filter.order = 'DESC';
      } else {
        this.filter.order = 'ASC';
      }
    }
    this.filter.orderBy = field;
    this.fetchConfiguration();
  }

  updateIconStatus() {
    return this.filter.order === 'ASC' ? 'assets/images/icon-sort-up.png' : 'assets/images/icon-sort-down.png';
  }

  addNewConfiguration() {
    this.ageMileageMatrix.dataList.unshift(new AgeMileageConfiguration());
  }

  updateItem(configuration: AgeMileageConfiguration) {
    configuration.brand = this.selectedBrand;
    this.http.saveAgeMileageConfiguration(configuration).subscribe(() => {
      SweetUtil.showSuccess('Updated configuration').then();
      this.fetchConfiguration();
    }, error => {
      if (error.status === 400) {
        this.sweetUtil.showError('Incomplete configuration data. Please ensure you have correctly captured all fields.').then();
      } else {
        this.sweetUtil.showError('Internal server error. Please try again later.').then();
      }
    });
  }

  removeItem(item: AgeMileageConfiguration) {
    this.ageMileageMatrix.dataList.splice(this.ageMileageMatrix.dataList.indexOf(item), 1);
  }

  onBrandSelected() {
    this.filter.brand = this.selectedBrand.id;
    this.fetchConfiguration();
  }

}
